// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"TransactionAntigoonScreen_titleWrapper__18hSY","primaryFieldsWrapper":"TransactionAntigoonScreen_primaryFieldsWrapper__uF1Bi"};